import React from "react";
import { SUPPORTED_SPORTS, SPORT_LABELS } from "../../lib/constants";
import { PuzzleDataContext } from "../../providers/PuzzleData";

function SportToggle() {
    const { sport, setSport } = React.useContext(PuzzleDataContext);

    return (
        <div className="inline-flex rounded-full bg-slate-800/80 p-1 gap-1 border border-slate-700/40">
            {SUPPORTED_SPORTS.map((code) => {
                const isActive = sport === code;
                return (
                    <button
                        key={code}
                        onClick={() => setSport(code)}
                        className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-300 ease-out ${
                            isActive
                                ? "bg-white text-slate-900 scale-105"
                                : "text-slate-300 hover:text-white hover:bg-slate-700/50"
                        }`}
                    >
                        {SPORT_LABELS[code]}
                    </button>
                );
            })}
        </div>
    );
}

export default SportToggle;
